import React from 'react';
import { Droppable } from 'react-beautiful-dnd';
import classNames from 'classnames';
import { TitleTextSmall } from 'Packages/FacetDesign/Components';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { FDStack } from '@facet-wealth/design';
import { getBorderRadius } from 'Components/utils';
import PropTypes from 'prop-types';
import DraggableStepSet from './DraggableStepSet';
import { LIST_TYPE_GROUP } from './useSmartAllocationDragAndDrop';

const useStyles = buildUseStyles('DroppableColumn', ((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    transition: 'background-color 0.2s ease',
    minHeight: '20px',
    ...getBorderRadius(theme.radius.md, { all: true }),
  },
  draggingOverActive: {
    backgroundColor: 'rgba(176, 211, 223, 0.2)',
  },
  draggingOverInactive: {
    backgroundColor: 'rgba(173, 173, 173, 0.7)',
  },
})));

export const DroppableColumn = ({
  groupTitle,
  isActiveStatus,
  groupSteps,
  onBreakGroup,
  isNeverDraggable,
  isCurrentlyNotDraggable,
  isCompatibleDropTarget,
  showActiveStatus,
  StepComponent,
}) => {
  const classes = useStyles();

  return (
    <FDStack direction={'column'}>
      {!isNeverDraggable && showActiveStatus && <TitleTextSmall
        value={`${isActiveStatus} steps`}
        color={isActiveStatus === 'Active' ? 'textPrimary' : 'textDisabled'}
      />
      }
      <Droppable
        droppableId={`${groupTitle}-${isActiveStatus}`}
        type={LIST_TYPE_GROUP}
        isCombineEnabled
      >
        {(dropProvided, snapshot) => {
          return (
            <div
              ref={dropProvided.innerRef}
              className={classNames(classes.root, {
                [classes.draggingOverActive]: snapshot.isDraggingOver === true && isActiveStatus === 'Active',
                [classes.draggingOverInactive]: snapshot.isDraggingOver === true && isActiveStatus === 'Inactive',
              })}
              {...dropProvided.droppableProps}
            >
              {groupSteps.map((steps, idx) => (
                <DraggableStepSet
                  key={steps[0].attr('stepSet')}
                  isNeverDraggable={isNeverDraggable}
                  isCurrentlyNotDraggable={isCurrentlyNotDraggable}
                  dragIdx={idx}
                  stepResources={steps}
                  onBreakGroup={onBreakGroup}
                  isDraggingOver={snapshot.isDraggingOver}
                  isCompatibleTarget={isCompatibleDropTarget(steps, snapshot.draggingOverWith)}
                  StepComponent={StepComponent}
                />
              ))}
              {dropProvided.placeholder}
            </div>
          );
        }}
      </Droppable>
    </FDStack>
  );
};

DroppableColumn.propTypes = {
  groupTitle: PropTypes.string.isRequired,
  isActiveStatus: PropTypes.oneOf(['Active', 'Inactive']).isRequired,
  groupSteps: PropTypes.array.isRequired,
  onBreakGroup: PropTypes.func.isRequired,
  isNeverDraggable: PropTypes.bool.isRequired,
  isCurrentlyNotDraggable: PropTypes.bool.isRequired,
  isCompatibleDropTarget: PropTypes.func.isRequired,
  StepComponent: PropTypes.func.isRequired,
  showActiveStatus: PropTypes.bool,
};
